import i18n from '@/lang';

//  时间
export const dateTime = [
  {
    label: i18n.t('Resource.DateOfRequest'),
    value: 'apply_time'
  },
  {
    label: i18n.t('receivablePayable.CompletionDate'),
    value: 'completed_time'
  },
  {
    label: i18n.t('basicData.BusinessStartDate'),
    value: 'business_period_start'
  },
  {
    label: i18n.t('basicData.BusinessEndDate'),
    value: 'business_period_end'
  }
];

// 状态
export const STATUS = {
  'PENDING': {
    label: i18n.t('receivablePayable.InReview'),
    type: 'warning',
    value: 'PENDING'
  },
  'APPROVED': {
    label: i18n.t('receivablePayable.Passed'),
    type: 'success',
    value: 'APPROVED'
  },
  'REJECT': {
    label: i18n.t('receivablePayable.Rejected'),
    type: 'danger',
    value: 'REJECT'
  },
  'RECALL': {
    label: i18n.t('receivablePayable.Withdrawn'), // 撤回
    type: 'info',
    value: 'RECALL'
  },
  'DELETED': {
    label: i18n.t('receivablePayable.Delete'),
    type: 'danger',
    value: 'DELETED'
  }
};

export const Table_Column = [
  {
    label: i18n.t('receivablePayable.ApprovalFormNumber'),
    prop: 'serialNumber',
    width: 160,
    className: 'batchNumber'
  },
  {
    label: i18n.t('basicData.status'),
    prop: 'status',
    width: 120
  },
  {
    label: i18n.t('receivablePayable.CompletionDate'),
    prop: 'completedTime',
    width: 160
  },
  {
    label: i18n.t('Resource.applicant'),
    prop: 'applicantName',
    width: 200
  },
  {
    label: i18n.t('customerManagements.customerType'),
    prop: 'customerType',
    width: 180
  },
  {
    label: i18n.t('basicData.CustomerName'),
    prop: 'customerName',
    width: 200
  },
  {
    label: 'CNPJ/CPF',
    prop: 'cnpj',
    width: 200
  },
  {
    label: i18n.t('basicData.BusinessStartDate'),
    prop: 'businessPeriodStart',
    width: 180
  },
  {
    label: i18n.t('basicData.BusinessEndDate'),
    prop: 'businessPeriodEnd',
    width: 180
  },
  {
    label: i18n.t('receivablePayable.Currency'),
    prop: 'currency',
    width: 100
  },
  {
    label: i18n.t('receivablePayable.OriginalCurrencyAmount'),
    prop: 'amount',
    width: 100
  },
  {
    label: i18n.t('receivablePayable.BrlCurrencyAmount'),
    prop: 'brlAmount',
    width: 100
  },
  {
    label: i18n.t('Resource.DateOfRequest'),
    prop: 'applyTime',
    width: 160
  },
  {
    label: i18n.t('basicData.Reason'),
    prop: 'paymentPurpose',
    width: 250
  },
  {
    label: i18n.t('basicData.annex'),
    prop: 'attachmentList',
    width: 250
  }
];
